import React, { Component } from "react";
import PropTypes from "prop-types";
import { evalScript } from "../../../utils/misc";
import { createPayPalCharge, payPalExecution } from "../../../utils/witbookingApi";

/*
 * How it works
 * -User clicks on ConfirmReservation
 * -Reservation is created on the backend, client gets success answer
 * -Application detects current device (mobile or desktop)
 *   if desktop opens new browser windows with THIS component (special route just for it (a.k.a. WITBOOKING_PAYMENT_ROUTE))
 *   if mobile redirects current window to THIS component
 * -[COMPONENT FLOW A] Component redirects to WitbookingPaymentSystem (a.k.a. PAYMENT_ROUTE)
 *   We must pass Locale / Current Domain / Reservation ID / propertyTicker / Environment(dev, prod)?
 * -User fills CC data in WitbookingPaymentSystem
 * -WitbookingPaymentSystem redirect to either our success or fail state
 * -[COMPONENT FLOW B] If success
 *   if on desktop the browser window is closed (check for window.opener) and the parent is redirected to the confirmation page
 *   if on mobile the (window.opener is null) the component redirect to the confirmation page
 * -[COMPONENT FLOW C] If fail (how?) the user is shown an error message with a button to try again which redirects to WITBOOKING_PAYMENT_ROUTE and start over.
 */

class PaypalBridge extends Component {
  constructor(props) {
    super(props);
    this.initialized = false;
    this.paypalButton = null;
    this.paypalPromise = null;
    this.reservationId = null;
    this.initialize = this.initialize.bind(this);
    this.handlePaymentResponse = this.handlePaymentResponse.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.startPaymentProcess = this.startPaymentProcess.bind(this);
    if (!window.paypal || !window.paypal.Button) {
      evalScript({
        scriptArr: [{ src: "https://www.paypalobjects.com/api/checkout.js" }],
        cb: result => {
          if (result) {
            this.initialize(this.props.locale);
          }
        },
      });
    } else {
      this.initialized = true;
    }
  }

  componentDidMount() {
    this.renderButton(this.props.locale);
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.transaction.amount !== this.props.transaction.amount ||
      nextProps.onPayment !== this.props.onPayment
    );
  }

  componentDidUpdate() {
    this.renderButton(this.props.locale);
  }

  initialize(locale) {
    this.initialized = true;
    this.renderButton(locale);
  }

  handlePaymentResponse(token, args) {
    this.props.globalLoading(true);
    this.props.onResponse({ token, args });
  }

  handleClose() {
    this.props.onClose();
  }

  startPaymentProcess(reservationId) {
    if (this.paypalPromise) {
      this.reservationId = reservationId;

      const paymentID = createPayPalCharge(
        {},
        {
          propertyTicker: this.props.propertyTicker,
          reservationId,
        }
      );

      this.paypalPromise.resolve(paymentID);
    }
  }

  renderButton(locale) {
    const parsedLocale = {
      es: "es_ES",
      ca: "es_ES",
      eu: "es_ES",
      en: "en_US",
      de: "de_DE",
      fr: "fr_FR",
      it: "it_IT",
      nl: "nl_NL",
      pt: "pt_PT",
      ru: "ru_RU",
      ko: "ko_KR",
    };

    if (!this.paypalButton || !this.initialized) {
      return;
    }
    // Clear previous buttons in case anything has changed
    this.paypalButton.innerHTML = "";
    window.paypal.Button.render(
      {
        env: window.__additionalData.PAYPAL_ENVIRONMENT || "production",

        commit: true, // Show a 'Pay Now' button

        locale: parsedLocale[locale],

        style: {
          label: "pay", // checkout | credit | pay
          size: "responsive", // small | medium | responsive
          shape: "rect", // pill | rect
          color: "blue", // gold | blue | silver
        },

        validate: (data, actions) => {
          if (this.props.error) {
            data.disable();
          }
        },
        payment: () => {
          this.props.onPayment();

          return new Promise((resolve, reject) => {
            this.paypalPromise = { resolve, reject };
          });
        },

        onAuthorize: data => {
          this.props.globalLoading(true);

          payPalExecution(
            {},
            {
              payerID: data.payerID,
              propertyTicker: this.props.propertyTicker,
              reservationId: this.reservationId,
            },
            this.props.onResponse
          );
        },

        onCancel: data => {
          console.log(data);
          this.handleClose();
        },

        onError: () => {
          if (this.props.setErrorCallback && typeof this.props.setErrorCallback === "function") {
            this.props.setErrorCallback();
          }
          console.log("Paypal an error occurred");
          this.handleClose();
        },
      },
      "#witbooking-paypal-button"
    );
  }

  render() {
    return <div id="witbooking-paypal-button" ref={button => (this.paypalButton = button)} />;
  }
}
PaypalBridge.propTypes = {
  onInitialize: PropTypes.func,
  onResponse: PropTypes.func,
  onClose: PropTypes.func,
  onPayment: PropTypes.func,
  globalLoading: PropTypes.func,
  configuration: PropTypes.object,
  transaction: PropTypes.object,
  idReservation: PropTypes.string,
  propertyTicker: PropTypes.string,
  locale: PropTypes.string,
  setErrorCallback: PropTypes.func,
};

export default PaypalBridge;
